<template>
  <div>
    <div class="card-body">
      <LoadingAnimation :isLoading="isLoading" />
      <h5
        class="card-text font-italic fw-bold fs-3 title-font"
        v-if="!isLoading"
      >
        {{ getCurrentQuestion?.topic }}
      </h5>
      <p v-if="!isLoading" class="card-text">
        {{ topicHelper }}
      </p>
      <p class="card-title" v-if="!isLoading">
        {{ getCurrentQuestion?.questionText }}
      </p>

      <div v-if="!isLoading">
        <div
          class="list-group"
          v-for="answer in answerList"
          :key="answer.id"
          @click="selectOption(answer)"
        >
          <button
            v-if="answer.index !== 0"
            :class="[
              'list-group-item ',
              { 'bg-orange-beaver': selectedOption?.id === answer.id }
            ]"
          >
            {{ answer.label }}
          </button>
        </div>
      </div>
      <div
        v-if="submitted && showNoAnswerValidation"
        class="alert alert-danger mt-1"
      >
        No response selected.
      </div>
      <div class="d-flex justify-content-between" v-if="!isLoading">
        <div class="mt-3">
          <button class="btn btn-secondary" @click="navigateBack">Back</button>
        </div>
        <div class="mt-3">
          <button class="btn btn-primary" @click="submitAnswer">
            Continue
          </button>
        </div>
      </div>
      <div
        class="mt-5"
        v-if="
          currentRecommendationData &&
          currentRecommendationData.length > 0 &&
          !isLoading
        "
      >
        <div class="text-start fw-bold fs-5">
          Opportunities For Improvement:
        </div>
        <div
          v-for="rec in currentRecommendationData"
          :key="rec.questionUUID"
          class="text-start"
        >
          <a
            class="icon-link text-decoration-none text-dark"
            :href="rec.opportunityForImprovementUrl"
            :title="rec.opportunityForImprovementText"
            target="_blank"
          >
            <i class="bi bi-link"></i>
            {{ rec.opportunityForImprovementText }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TOPICS from "@/data/Topic.js";

import { mapGetters, mapActions } from "vuex";
import LoadingAnimation from "@/components/LoadingAnimation.vue";
export default {
  name: "MultipleChoice",
  components: {
    LoadingAnimation
  },
  data() {
    return {
      question: {
        text: "Placeholder question?"
      },
      selectedOption: null,
      submitted: false,
      showNoAnswerValidation: false,
      isLoading: false
    };
  },
  computed: {
    ...mapGetters([
      "getCurrentQuestion",
      "getQuestionData",
      "getRecommendationData",
      "getSurveyAnswers",
      "getAnswerData"
    ]),
    answerList() {
      return Object.values(this.getAnswerData);
    },
    topicHelper() {
      if (!this.getCurrentQuestion) return "";
      const topic = Object.values(TOPICS).find(
        (topic) => topic.DISPLAY_TITLE === this.getCurrentQuestion.topic
      );
      return topic ? topic.DISPLAY_QUESTION : "";
    },
    currentRecommendationData() {
      if (!this.getCurrentQuestion) return "";
      return this.getRecommendationData.filter(
        (el) => el.questionUUID === this.getCurrentQuestion.uuid
      );
    }
  },
  created() {
    this.fetchAnswerData();
  },
  methods: {
    ...mapActions([
      "addSurveyAnswer",
      "setCurrentQuestion",
      "setSurveyComplete",
      "updateSurveyAnswer",
      "fetchAnswerData"
    ]),
    selectOption(answer) {
      this.selectedOption = answer;
      this.submitted = false;
      this.showNoAnswerValidation = false;
    },
    submitAnswer() {
      this.submitted = true;
      if (!this.selectedOption) {
        this.handleValidation();
        return;
      }
      this.isLoading = true;

      setTimeout(() => {
        const existingAnswerIndex = this.getSurveyAnswers.findIndex(
          (answer) => answer.questionUUID === this.getCurrentQuestion.uuid
        );

        if (existingAnswerIndex !== -1) {
          this.updateSurveyAnswer({
            index: existingAnswerIndex,
            newAnswer: {
              questionUUID: this.getCurrentQuestion.uuid,
              topic: this.getCurrentQuestion?.topic,
              answer: this.selectedOption.id
            }
          });
        } else {
          this.addSurveyAnswer({
            questionUUID: this.getCurrentQuestion.uuid,
            topic: this.getCurrentQuestion?.topic,
            answer: this.selectedOption.id
          });
        }

        let nextQuestion;
        this.getQuestionData.forEach((question) => {
          if (
            this.getCurrentQuestion.index ===
            this.getQuestionData.length - 1
          ) {
            return;
          }
          if (question.index === this.getCurrentQuestion.index + 1) {
            nextQuestion = question;
          }
        });

        this.setCurrentQuestion(nextQuestion);
        this.selectedOption = null;
        this.isLoading = false;
      }, 1000);
    },
    handleValidation() {
      this.showNoAnswerValidation = true;
    },
    navigateBack() {
      this.isLoading = true;
      setTimeout(() => {
        let previousQuestion;
        this.getQuestionData.forEach((question) => {
          if (
            this.getCurrentQuestion.index ===
            this.getQuestionData.length - 1
          ) {
            this.setSurveyComplete(true);
            return;
          }
          if (question.index === this.getCurrentQuestion.index - 1) {
            previousQuestion = question;
          }
        });

        this.setCurrentQuestion(previousQuestion);
        this.selectedOption = null;
        this.isLoading = false;
      }, 1000);
    },
    setPreviousAnswer() {
      const answeredQuestion = this.getSurveyAnswers.find(
        (answer) => answer.questionUUID === this.getCurrentQuestion.uuid
      );
      if (answeredQuestion) {
        this.selectedOption = this.answerList.find(
          (answer) => answer.id === answeredQuestion.answer
        );
      } else {
        this.selectedOption = null;
      }
    }
  },
  watch: {
    getCurrentQuestion: {
      handler(newVal) {
        if (newVal) {
          this.setPreviousAnswer();
        }
      },
      deep: true
    },

    selectedOption(val1, val2) {
      if (val1 !== val2) {
        this.submitted = false; // reset submitted when answer changes
      }
    }
  }
};
</script>

<style scoped>
.card-title {
  font-size: 1.5rem;
  font-weight: bold;
}

.checkmark {
  color: green;
  margin-left: 10px;
}

.card-text {
  font-size: 1.2rem;
}
.bg-orange-beaver {
  background-color: #d7400989;
}

.list-group-item:hover {
  background-color: #d7400928;
}

.icon-link:hover {
  text-decoration: underline !important;
}
</style>
